var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"back-icon",on:{"click":_vm.onBack}},[_c('img',{attrs:{"src":require("@/assets/annualReport/back.png")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }